import type { ReactNode } from "react";
import { IntlProvider } from "react-intl";

import englishMessages from "./lang/en.json";

export const defaultLocale = "en";

export function TranslationsProvider({ children }: { children: ReactNode }): React.JSX.Element {
  return (
    <IntlProvider locale={defaultLocale} defaultLocale={defaultLocale} messages={englishMessages}>
      {children}
    </IntlProvider>
  );
}
